import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getHsaSettings = {
  name: "getHsaSettings" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ enabled: z.boolean() }),
};
